"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemDeps = systemDeps;
const cmds = require("./composer-cmds");
function systemDeps(basePath, options) {
    var _a, _b;
    const composerOk = (_a = options.composerIsFine) !== null && _a !== void 0 ? _a : cmds.cmdReturnsOk(cmds.globalComposer.version());
    const composerPharOk = (_b = options.composerPharIsFine) !== null && _b !== void 0 ? _b : cmds.cmdReturnsOk(cmds.localComposer.version());
    let finalVersionsObj = {};
    if (options.systemVersions &&
        Object.keys(options.systemVersions).length > 0) {
        // give first preference to a stub
        finalVersionsObj = options.systemVersions;
    }
    else if (composerOk || composerPharOk) {
        const composer = composerOk ? cmds.globalComposer : cmds.localComposer;
        const output = cmds.execWithResult(composer.listPlatformDeps(), basePath);
        const versionsObj = JSON.parse(output).platform;
        versionsObj.forEach(({ name, version }) => {
            finalVersionsObj[name] = version;
        });
    }
    else {
        // TODO: tell the user we are not reporting accurately system versions, so some version info may not be exact
    }
    return finalVersionsObj;
}
//# sourceMappingURL=system-deps.js.map